import DavidsStory from "../assets/files/culture/davids_story.pdf";
import DoctrinForSustainability from "../assets/files/culture/doctrine_for_sustainability.pdf";
import EcologyAndCulture from "../assets/files/culture/ecology_and_culture_of_water.pdf";
import FoodProductionIssues from "../assets/files/culture/food_production_issues.pdf";
import HumanBeings from "../assets/files/culture/human_beings_of_the_north_branch.pdf";
import RealitiesOfCO2 from "../assets/files/culture/realities_of_co2.pdf";
import WhatIsASavanna from "../assets/files/culture/what_is_a_savanna.pdf";
import WhyDoWeThink from "../assets/files/culture/why_do_we_think.pdf";

interface EssayType {
  name: string;
  file: string;
}

export const CultureList: EssayType[] = [
  {
    name: "David's Story",
    file: DavidsStory,
  },
  {
    name: "Doctrine For Sustainability",
    file: DoctrinForSustainability,
  },
  {
    name: "Ecology and Culture of Water",
    file: EcologyAndCulture,
  },
  {
    name: "Food Production Issues",
    file: FoodProductionIssues,
  },
  {
    name: "Human Beings of the North Branch",
    file: HumanBeings,
  },
  {
    name: "Realities of CO2",
    file: RealitiesOfCO2,
  },
  {
    name: "What is a Savannah?",
    file: WhatIsASavanna,
  },
  {
    name: "Why Do We Think What We Think",
    file: WhyDoWeThink,
  },
];

export default CultureList;
export type { EssayType };
